import { FC, useState } from 'react';
import { SchedulerLogsTable } from "@/features/scheduler-logs";
import { PageWrapper } from "@/components/ui";
import { RefreshCw } from "lucide-react";

const SchedulerLogsPage: FC = () => {
    const [refreshFn, setRefreshFn] = useState<(() => void) | null>(null);

    return (
        <PageWrapper
            title="Scheduler Runs"
            subtitle="View and monitor RSS scheduler execution runs, efficiency, errors, and metrics."
            headerActions={
                <button
                    onClick={() => refreshFn?.()}
                    className="flex items-center gap-2 px-3 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-all shadow-sm"
                    title="Refresh Logs"
                >
                    <RefreshCw className="w-4 h-4" />
                    Refresh
                </button>
            }
        >
            <SchedulerLogsTable onRefreshRequest={setRefreshFn} />
        </PageWrapper>
    );
};

export default SchedulerLogsPage;
